import { Device } from '@/types/device'
import { DeploymentDeviceInfo } from './DeploymentDeviceInfo'

type DeploymentDeviceTabProps = {
  device: Device
  onRefresh: () => void
}

export const DeploymentDeviceTab = ({
  device,
  onRefresh
}: DeploymentDeviceTabProps) => {
  return <DeploymentDeviceInfo device={device} onRefresh={onRefresh} />
}
